export default __webpack_public_path__ + "static/media/waste_unselected.2f0943d7.svg";